var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { addMonths, addWeeks, endOfDay, endOfMonth, endOfWeek, isBefore, isSameDay, startOfDay, startOfMonth, startOfWeek } from "../../../date.util";
import { min } from "lodash";
import { SectorType } from "../../../../models/sector/sector.model";
import { CommonThemeColors } from "../../../../components/theme";
import { toJsDate } from "../../../calendarTimezone";
import { AvailabilityType } from "../../../../models/availability/availability.model";
export var SECTORS_SHOW_CALENDAR_AVAILABILITY = [SectorType.SPA, SectorType.RESTAURANT];
// As you can see, the accommodation is excluded from this list
export var SECTORS_WITH_PERMITTED_UNASSIGNED_ROW = [SectorType.SPA, SectorType.RESTAURANT, SectorType.OTHER];
export var SHOW_PACKAGE_ICON_SECTOR_TYPES = [
    SectorType.SPA,
    SectorType.ACCOMMODATION,
    SectorType.OTHER
];
export var AVAILABILITY_QUERY_KEY = 'availability';
export var RESERVATIONS_QUERY_KEY = 'reservations';
export var FIRST_RESERVATION_TODAY_QUERY_KEY = 'firstReservationToday';
export var SERVICE_RESERVATIONS_QUERY_KEY = 'serviceReservations';
export var UnassignedType;
(function (UnassignedType) {
    UnassignedType["UNASSIGNED_RESOURCE"] = "UNASSIGNED_RESOURCE";
    UnassignedType["UNASSIGNED_SERVICE"] = "UNASSIGNED_SERVICE";
})(UnassignedType || (UnassignedType = {}));
export var BLOCK_OVERLAP_SECONDS = 3;
export var MORNING_START_TIME = '05:00';
export var MORNING_END_TIME = '10:59';
export var DAY_START_TIME = '11:00';
export var DAY_END_TIME = '16:59';
export var EVENING_START_TIME = '17:00';
export var EVENING_END_TIME = '23:59';
export var inUnassignedRow = function (reservation) {
    var _a, _b;
    if (((_a = reservation === null || reservation === void 0 ? void 0 : reservation.resourceIds) === null || _a === void 0 ? void 0 : _a.some(function (id) { return id === null || id === void 0 ? void 0 : id.startsWith(UnassignedType.UNASSIGNED_SERVICE); }))
        || ((_b = reservation === null || reservation === void 0 ? void 0 : reservation.resourceIds) === null || _b === void 0 ? void 0 : _b.some(function (id) { return (id === null || id === void 0 ? void 0 : id.startsWith(UnassignedType.UNASSIGNED_RESOURCE))
            || !(reservation === null || reservation === void 0 ? void 0 : reservation.resourceIds); }))) {
        return true;
    }
    return false;
};
export var calculateEarliestReservationByDateRange = function (startDate, endDate, reservationsNoStatusTrigger, automaticNavigation) {
    // Sorting by start date ASC - need to use Date field instead of expectedStartTime which is just a string
    var sortedReservations = __spreadArray([], reservationsNoStatusTrigger, true).sort(function (a, b) { var _a, _b; return ((_a = a.expectedStartDate) === null || _a === void 0 ? void 0 : _a.getTime()) - ((_b = b.expectedStartDate) === null || _b === void 0 ? void 0 : _b.getTime()); });
    var reservationStartDates = sortedReservations.map(function (r) { return r.expectedStartDate; });
    var earliestReservationStartDate = reservationStartDates[0];
    // Make sure to allow the navigation to other dates even though if the earliest reservation is later
    if (!automaticNavigation) {
        if (isBefore(startDate, earliestReservationStartDate) && !isSameDay(startDate, earliestReservationStartDate))
            return startDate;
    }
    // Filtering relevant reservations for the selected time view (day / week / month)
    var validReservationsByStartDate = reservationStartDates.filter(function (date) {
        return date >= startDate && date <= endDate;
    });
    // Find the earliest reservation from the valid ones
    return validReservationsByStartDate.length ? min(validReservationsByStartDate) : startDate;
};
export var calculateEndDateWithTimelineSpan = function (start, timelineSpan) {
    if (!timelineSpan)
        return undefined;
    switch (timelineSpan || 'day') {
        case "day":
            return endOfDay(start);
        case "week":
            return endOfDay(addWeeks(start, 1));
        case "month":
            return endOfDay(addMonths(start, 1));
    }
};
// By doing this we ensure that resources take original positions in the calendar
export var sortSelectedResources = function (resourcesToSort, resources, mbscResourceColumnType, services) {
    // First add the unassigned row on the top
    var unassignedResourcesRow = resourcesToSort.find(function (r) { return r.name === 'Unassigned'; });
    var sortedMbscResources = unassignedResourcesRow ? [unassignedResourcesRow] : [];
    // Make a distinction between resources and services (both can represent mbsc resource column)
    var originalIds = mbscResourceColumnType === 'services' ? ((services === null || services === void 0 ? void 0 : services.map(function (s) { return s === null || s === void 0 ? void 0 : s.id; })) || []) :
        ((resources === null || resources === void 0 ? void 0 : resources.map(function (r) { return r === null || r === void 0 ? void 0 : r.id; })) || []);
    if (!originalIds.length)
        return undefined;
    originalIds.forEach(function (id) {
        var foundResource = resourcesToSort.find(function (r) { return (r === null || r === void 0 ? void 0 : r.id) === id; });
        if (foundResource) {
            sortedMbscResources.push(foundResource);
        }
    });
    return sortedMbscResources;
};
export var getTimelineSpanDates = function (timelineSpan, navigatedDate) {
    var periodStart;
    var periodEnd;
    switch (timelineSpan) {
        case "day":
            periodStart = startOfDay(navigatedDate !== null && navigatedDate !== void 0 ? navigatedDate : new Date());
            periodEnd = endOfDay(navigatedDate !== null && navigatedDate !== void 0 ? navigatedDate : new Date());
            break;
        case "week":
            periodStart = startOfWeek(navigatedDate !== null && navigatedDate !== void 0 ? navigatedDate : new Date());
            periodEnd = endOfWeek(navigatedDate !== null && navigatedDate !== void 0 ? navigatedDate : new Date());
            break;
        case "month":
            periodStart = startOfMonth(navigatedDate !== null && navigatedDate !== void 0 ? navigatedDate : new Date());
            periodEnd = endOfMonth(navigatedDate !== null && navigatedDate !== void 0 ? navigatedDate : new Date());
            break;
        default:
            throw new Error("Invalid timeline span");
    }
    return [periodStart, periodEnd];
};
export var getFullDayRange = function (date) {
    var start = startOfDay(date);
    var end = endOfDay(date);
    return [start, end];
};
export var daySlices = function (reservationDaySlice, timelineSpan) {
    var timelineStart = '00:00';
    var timelineEnd = '23:59';
    if (reservationDaySlice && timelineSpan === 'day') {
        switch (reservationDaySlice) {
            case "morning":
                timelineStart = MORNING_START_TIME;
                timelineEnd = MORNING_END_TIME;
                break;
            case "day":
                timelineStart = DAY_START_TIME;
                timelineEnd = DAY_END_TIME;
                break;
            case "evening":
                timelineStart = EVENING_START_TIME;
                timelineEnd = EVENING_END_TIME;
                break;
            case "now":
                var now = new Date();
                timelineStart = "".concat(now.getHours(), ":").concat(now.getMinutes());
                timelineEnd = '23:59';
                break;
        }
    }
    else {
        timelineStart = '00:00';
        timelineEnd = '23:59';
    }
    return [timelineStart, timelineEnd];
};
export var checkBlockOverlapping = function (event, availabilityColors) {
    // Filter the block availabilities for given resource
    var resourceBlockAvailabilities = availabilityColors
        .filter(function (ac) { return ac.resource === event.event.resource; })
        .filter(function (ac) { return ac.background === CommonThemeColors.sys.availability.lightRed; });
    return resourceBlockAvailabilities.some(function (ac) {
        var start = toJsDate(ac.start);
        var end = toJsDate(ac.end);
        // ISO string / timezone aware object when the calendar renders in the organization's timezone
        var eventStart = toJsDate(event.event.start);
        var eventEnd = toJsDate(event.event.end);
        // Check if the event overlaps with the availability color time range
        return eventStart < end && eventEnd > start;
    });
};
/*
    When dragging an event, we want to check if the resource is already assigned to the reservation
    Case: In spa calendar if someone wants to drag the slot to the position where the another resource is already assigned
    -> Trigger dragging error
*/
export var slotContainsExistingResource = function (newEvent, oldEvent, reservations) {
    var _a;
    var newResourceId = newEvent.resource;
    var reservationId = newEvent.reservationId;
    var reservation = reservations.find(function (res) { return res.id === reservationId; });
    // Only if the slot is moved from one resource column to some other
    // Moving inside the same resource column is not a problem
    return ((_a = reservation === null || reservation === void 0 ? void 0 : reservation.resourceIds) === null || _a === void 0 ? void 0 : _a.includes(newResourceId)) && (oldEvent === null || oldEvent === void 0 ? void 0 : oldEvent.resource) !== newResourceId;
};
/*
    Here we want to make sure that blocks or CLOSED availabilities are always at the end of the list
    This makes them come to the front in the calendar view, on top of some availabilities that might exist during the same period
*/
export var sortAvailabilitiesByAvailabilityType = function (availabilities) {
    return __spreadArray([], availabilities, true).sort(function (a, b) {
        // CLOSED always comes last
        if (a.type === AvailabilityType.CLOSED && b.type !== AvailabilityType.CLOSED)
            return 1;
        if (b.type === AvailabilityType.CLOSED && a.type !== AvailabilityType.CLOSED)
            return -1;
        return 0;
    });
};
/*
    Count indicates how many color variations to generate
    1) If the number of connections is high -> use high count to generate more variations
    2) If the number of connections is low -> use low count to generate less variations -> then the difference will be more visible
*/
export var generateColorVariationsForOverlappingConnections = function (baseColor, count) {
    if (count === void 0) { count = 5; }
    if (!baseColor)
        return [];
    // Convert hex to RGB
    var hex = baseColor.replace('#', '');
    var r = parseInt(hex.substr(0, 2), 16);
    var g = parseInt(hex.substr(2, 2), 16);
    var b = parseInt(hex.substr(4, 2), 16);
    var variations = [];
    // Generate variations from darkest to lightest
    for (var i = 0; i < count; i++) {
        var factor = void 0;
        if (count === 1) {
            factor = 1;
        }
        else {
            // Start from very dark (0.2) to very light (0.9 mix with white)
            // Create maximum distance between variations
            var step = i / (count - 1);
            if (step <= 0.5) {
                // First half: very dark to original color
                factor = 0.2 + step * 1.6; // 0.2 to 1.0
            }
            else {
                // Second half: original to very light (mix with white)
                var lightStep = (step - 0.5) * 2; // 0 to 1
                factor = 1 + lightStep * 0.8; // 1.0 to 1.8
            }
        }
        var newR = void 0, newG = void 0, newB = void 0;
        if (factor <= 1) {
            // Darken by multiplying
            newR = Math.round(r * factor);
            newG = Math.round(g * factor);
            newB = Math.round(b * factor);
        }
        else {
            // Lighten by mixing with white
            var mixFactor = factor - 1; // 0 to 0.8
            newR = Math.round(r + (255 - r) * mixFactor);
            newG = Math.round(g + (255 - g) * mixFactor);
            newB = Math.round(b + (255 - b) * mixFactor);
        }
        // Ensure values are within 0-255 range
        newR = Math.min(255, Math.max(0, newR));
        newG = Math.min(255, Math.max(0, newG));
        newB = Math.min(255, Math.max(0, newB));
        var newHex = '#' +
            newR.toString(16).padStart(2, '0') +
            newG.toString(16).padStart(2, '0') +
            newB.toString(16).padStart(2, '0');
        variations.push(newHex);
    }
    return variations;
};
export var getAvailableViewModesPerSectorType = function (sectorType) {
    switch (sectorType) {
        // For restaurant we only want to show timeline view
        case SectorType.RESTAURANT:
            return ['timeline'];
        // For others (SPA, ACCOMMODATION, RENTALS, WEEKLY PLANNER) we want to show both timeline and timeGrid views
        default:
            return ['timeline', 'timeGrid'];
    }
};
export var getAvailableTimeRangesPerSectorType = function (sectorType) {
    switch (sectorType) {
        // For restaurant we want to show all time ranges
        case SectorType.RESTAURANT:
            return ['day'];
        default:
            return ['day', 'week', 'month'];
    }
};
export var getAvailableTimeRangesPerViewMode = function (viewMode) {
    switch (viewMode) {
        case 'timeGrid':
            return ['day', 'week'];
        case 'timeline':
            return ['day', 'week', 'month'];
        default:
            return ['day', 'week', 'month'];
    }
};
export var getDefinedMbscResources = function (mbscResources) {
    return mbscResources === null || mbscResources === void 0 ? void 0 : mbscResources.filter(function (r) { return !r.id.toString().startsWith(UnassignedType.UNASSIGNED_RESOURCE); });
};
